import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-500 mb-2">{contactData.subtitle}</p>
          <p className="text-sm text-foreground-700 leading-relaxed mb-8">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactData.methods.map((method) => (
              <div
                key={method.label}
                className="bg-background-100 rounded-lg p-5 flex flex-col items-center text-center"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full mb-3">
                  <i className={`${method.icon} text-primary-500 text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1">
                  {method.label}
                </h3>
                <p className="text-sm text-foreground-600 break-all">{method.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}